import Journal, { makeRecord, makeJokerRecord } from '@/models/journal'
import Vue from 'vue'
// initial state
const state = () => ({
	current: new Journal(),
	catalogEntryFromLabel: undefined,
	edited: {
		record: undefined,
		field: undefined,
		value: undefined,
		error: undefined,
	},
})

// getters
const getters = {
	records: state => {
		return state.current.records
	},
	editing: state => {
		return state.edited.record !== undefined
	},
}

// mutations
const mutations = {
	RESET_JOURNAL(state) {
		state.current = new Journal()
	},
	ADD_RECORD(state, record) {
		state.current.add(record)
	},
	ADD_ENTRY(state, entry) {
		const record = makeRecord(entry)
		state.current.add(record)
	},
	ADD_JOKER(state, entryType) {
		const record = makeJokerRecord(entryType, `joker ${entryType}`)
		state.current.add(record)
	},
	REMOVE_RECORD(state, record) {
		state.current.remove(record)
	},
	SET_CATALOG_ENTRY_FROM_LABEL(state, entry) {
		state.catalogEntryFromLabel = entry
	},
	SET_EDITED(state, { record, field, value, error = '' }) {
		state.edited = {
			record,
			field,
			value,
			error,
		}
	},
	SET_EDITED_ERROR(state, error = '') {
		state.edited.error = error
	},
	SET_EDITED_VALUE(state, value) {
		state.edited.value = value
	},
	RESET_EDITED(state) {
		state.edited = {
			record: undefined,
			field: undefined,
			value: undefined,
			error: undefined,
		}
	},
	SAVE_EDITED_RECORD(state) {
		switch (state.edited.field) {
			case 'label': {
				state.edited.record.entry.label = state.edited.value
				state.edited.record.modified = true

				if (state.catalogEntryFromLabel) {
					const src = state.catalogEntryFromLabel

					state.edited.record.entry.cats = [...src.cats]
					state.edited.record.entry.type = src.type
					state.edited.record.entry.code = src.code
					state.edited.record.entry.description = src.description
				}

				break
			}
			case 'code':
				state.edited.record.entry.code = state.edited.value
				state.edited.record.modified = true
				break
			case 'comment':
				state.edited.record.comment = state.edited.value				
				break
			case 'qty':
				state.edited.record.qty = state.edited.value
				break
			case 'cat1':
				Vue.set(state.edited.record.entry.cats, 0, state.edited.value)
				state.edited.record.modified = true
				break
			case 'cat2':
				Vue.set(state.edited.record.entry.cats, 1, state.edited.value)
				state.edited.record.modified = true
				break
			case 'cat3':
				Vue.set(state.edited.record.entry.cats, 2, state.edited.value)
				state.edited.record.modified = true
				break
			default:
		}
	},
}

// actions
const actions = {
	resetJournal({ commit }) {
		commit('RESET_JOURNAL')
	},
	addRecord({ commit }, record) {
		commit('ADD_RECORD', record)
	},
	addEntry({ commit }, entry) {
		commit('ADD_ENTRY', entry)
	},
	addJoker({ commit }, entryType) {
		commit('ADD_JOKER', entryType)
	},
	removeRecord({ commit }, record) {
		commit('REMOVE_RECORD', record)
	},
	setEdited({ commit }, { record, field }) {
		commit('SET_EDITED', { record, field, value: record.getEditValue(field) })
	},
	setEditedError({ commit }, error) {
		if (state.edited.record) commit('SET_EDITED_ERROR', error)
	},
	setEditedValue({ state, commit }, value) {
		if (state.edited.record) commit('SET_EDITED_VALUE', value)
	},
	resetEdited({ commit }) {
		commit('RESET_EDITED')
	},
	saveEdited({ commit, state, dispatch }) {
		// ignore if already saved (and so state.edited has already been reinitialized)
		if (state.edited.record === undefined) return false
		// ignore if there are errors
		if (state.edited.error) {
			console.error(
				`Caught error while editing ${state.edited.field} => skipping update`,
			)
			dispatch('resetEdited')
			return false
		}
		try {
			state.edited.record.checkEditValue(state.edited.field, state.edited.value) // will throw on errors
			// everything's fine, we can update the record
			commit('SAVE_EDITED_RECORD')
			// reset the edited state
			dispatch('resetEdited')
			return true
		} catch (e) {
			// ignore error (we should get here)
			console.error(
				`Caught error while editing ${state.edited.field}: ${e.message}`,
			)
			dispatch('resetEdited')
			return false
		}
	},
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
}
